import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordLengthMessage: {
    id: 'InputPassword.PasswordLengthMessage',
    description: 'Password Length Text for Valid Password',
    defaultMessage: '10 characters minimum',
  },
  affirmInfoAlt: {
    id: 'Pdp.affirmInfo.alt',
    description: 'Affirm Icon Aria Label',
    defaultMessage: 'Affirm Information Link',
  },
});
